import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';


/*

Props:


*/

const StyledSpan = styled.span`
    font-family: 'Open Sans', sans-serif;
    color: ${props => (props.colorPrimary) ? constants.color.primary : 'rgb(123,123,123)'};
    font-size: 16px;
`;

const ModuleSpan = ({ styles, children, ...rest }) => (
    <StyledSpan style = {styles} {...rest}>
        { children }
    </StyledSpan>
)

export default ModuleSpan



// WEBPACK FOOTER //
// ./src/js/components/ModuleList/ModuleSpan.jsx